import styled from 'styled-components';

export const ModalContainer = styled.div`
  margin: 48px 36px;
`;
